import styled from '@emotion/styled';
import { Table } from 'antd';
import { sumBy } from 'lodash';
import { useEffect, useState } from 'react';
import { formatNum } from '../../../../../shared/constants';

const Container = styled.div`
  color: var(--mt-text);
`;

export const BGGlobale = ({ bg }: { bg: any[] }) => {
  const [globale, setGlobale] = useState<any[]>([]);

  useEffect(() => {
    if (bg.length !== 0) {
      setGlobale([
        ...bg,
        {
          intitule_compte: 'Total',
          sum_credit: sumBy(bg, 'sum_credit'),
          sum_debit: sumBy(bg, 'sum_debit'),
          sum_solde: sumBy(bg, 'sum_solde'),
        },
      ]);
    }
  }, [bg]);

  return (
    <Container>
      <Table
        className='balance-table'
        columns={COLUMNS}
        dataSource={globale}
        rowClassName={(row, index) =>
          `${index % 2 === 0 ? 'even-row' : 'odd-row'} ${
            row.intitule_compte === 'Total' ? 'total-row' : ''
          }`
        }
        size='small'
        loading={bg.length === 0 ? true : false}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </Container>
  );
};

const COLUMNS = [
  {
    title: 'Intitulé de compte',
    dataIndex: 'intitule_compte',
  },
  {
    title: 'Cumul Crédit',
    dataIndex: 'sum_credit',
    render: (cell: any) => <span className='amount-cell'>{formatNum(cell)}</span>,
    align: 'right' as const,
  },
  {
    title: 'Cumul Débit',
    dataIndex: 'sum_debit',
    render: (cell: any) => <span className='amount-cell'>{formatNum(cell)}</span>,
    align: 'right' as const,
  },
  {
    title: 'Solde',
    dataIndex: 'sum_solde',
    render: (cell: any) => <span className='amount-cell'>{formatNum(cell)}</span>,
    align: 'right' as const,
  },
];
